export const UPDATE_USER_NAME: "UPDATE_USER_NAME" = "UPDATE_USER_NAME";
export const UPDATE_USER_EMAIL: "UPDATE_USER_EMAIL" = "UPDATE_USER_EMAIL";
export const UPDATE_USER_PASSWORD: "UPDATE_USER_PASSWORD" =
  "UPDATE_USER_PASSWORD";
export const UPDATE_USER_TOKEN: "UPDATE_USER_TOKEN" = "UPDATE_USER_TOKEN";
export const LOG_IN_USER: "LOG_IN_USER" = "LOG_IN_USER";
export const LOG_OUT_USER: "LOG_OUT_USER" = "LOG_OUT_USER";
export const EMAIL_SENT: "EMAIL_SENT" = "EMAIL_SENT";
export const PASSWORD_SENT: "PASSWORD_SENT" = "PASSWORD_SENT";
export const UPDATE_USER_EDIT_STATUS: "UPDATE_USER_EDIT_STATUS" =
  "UPDATE_USER_EDIT_STATUS";
export const RESET_USER_EDIT_STATUS: "RESET_USER_EDIT_STATUS" =
  "RESET_USER_EDIT_STATUS";
export const RESET_USER_PASSWORD: "RESET_USER_PASSWORD" = "RESET_USER_PASSWORD";
